import { render, staticRenderFns } from "./backend-function.vue?vue&type=template&id=cf81a9fe&"
import script from "./backend-function.vue?vue&type=script&lang=js&"
export * from "./backend-function.vue?vue&type=script&lang=js&"
import style0 from "./backend-function.vue?vue&type=style&index=0&id=cf81a9fe&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports